<template lang="pug">
  button.lei-btn(:class="classes", @click="$emit('click')")
    slot
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
    type: {
      type: String,
      default: 'turquoise-keyline',
    },
    custom: {
      type: Boolean,
      default: false,
    },
    fill: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes () {
      return !this.custom ? [ this.type, this.size, this.fill ? 'fill' : 'simple', ] : ''
    },
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  fill($bg-color, $border-color = transparent, $color = $white-color, $border-width = 2px)
    background-color $bg-color
    border $border-width solid
    border-color $border-color
    color $color
  .lei-btn
    min-width 100px
    height $input-md
    display inline-flex
    align-items center
    justify-content center
    padding 10px 20px
    font-size 95%
    font-weight bold
    cursor pointer
    border-radius: 1.5rem
    &.sm
      height $input-sm
    &.md
      height $input-md
    &.lg
      height $input-lg
    &.default-bold
      fill(transparent, $default-color-bold, $default-color-bold)
    &.default
      fill(transparent, $default-color-middle, $default-color-bold)
    &.grey
      fill(transparent, $default-color-middle-1, $default-color-bold)
    &.primary
      fill(transparent, $primary-color, $primary-color)
    &.round
      fill(transparent, $turquoise-color, $cyprus-color, 1px)
      border-radius 20px
      box-shadow -4px 7px 12px -11px rgba(0,0,0,0.75)
      font-weight 600

      &:hover
        border-color #94EBDE

    &.fill
      &.config
        fill($default-color-light-1, $default-color-middle-1, $default-color, 1px)
        font-weight 500
      &.default
        fill($default-color-bold)
      &.grey
        fill($default-color-middle)
      &.primary
        fill($primary-color)
        &:disabled
          fill($primary-color-light-5)
    &:disabled
      cursor not-allowed


  @media (max-width: $tablet)
    .lei-btn
      width 100%
</style>



// WEBPACK FOOTER //
// src/components/lei-components/LeiBtn.vue